module.exports = "/_next/static/media/8ff45e34ae49977fa94e3e874c394d6a.svg";